export enum Actions {
  setActivitySession = 'setActivitySession',
  setInBetReferral = 'setInBetReferral',
  toggleIsSportsBook = 'toggleIsSportsBook',
  setIsSportsBook = 'setIsSportsBook',
  setSports = 'setSports',
  setQueryStrings = 'setQueryStrings',
  setLiveScores = 'setLiveScores',
  clearLiveScores = 'clearLiveScores',
  clearQueryStrings = 'clearQueryStrings',
  setFilter = 'setFilter',
  addNotification = 'addNotification',
  clearNotifications = 'clearNotifications',
  clearNotificationsOfDataType = 'clearNotificationsOfDataType',
  clearPeripheralNotifications = 'clearPeripheralNotifications',
  setBalance = 'setBalance',
  openKeyboard = 'openKeyboard',
  closeKeyboard = 'closeKeyboard',
  setKeyboardValue = 'setKeyboardValue',
  clearKeyboardValue = 'clearKeyboardValue',
  setMinStake = 'setMinStake',
  setChangePassword = 'setChangePassword',
  setPasswordExpiringFlow = 'setPasswordExpiringFlow',
  updateMarketWithMovingLines = 'moving-lines.update-with',
  patchMovingLineDataOnly = 'moving-lines.patch',
  setBetslipSelectedTeaserLevel = 'setBetslipSelectedTeaserLevel',
  setSelections = 'setSelections',
  activateView = 'activateView',
  activateBestView = 'activateBestView',
  addSelection = 'addSelection',
  setBetslipOpen = 'setBetslipOpen',
  removeSelection = 'removeSelection',
  clearSelections = 'clearSelections',
  updateStakes = 'updateStakes',
  toggleBetWithCredits = 'toggleBetWithCredits',
  setDeviceInfo = 'device.set-info',
  setIncreaseDepositLimitRequired = 'player-identification.set-increase-deposit-limit-required',
  setIncreaseDepositLimitView = 'player-identification.set-view',
  setIncreaseDepositLimitJourney = 'player-identification.set-journey',
  setFacialSimilarityError = 'player-identification.set-facial-similarity-error',
  resetPlayerIdentification = 'player-identification.reset',
  updatePlayableBalance = 'updatePlayableBalance',
  resetDepositToWallet = 'resetDepositToWallet',
  depositToMobileWallet = 'depositToMobileWallet',
  depositToMobileWalletActive = 'depositToMobileWalletActive',
  setBalanceCommittedToWallet = 'setBalanceCommittedToWallet',
  resetBalanceCommittedToWallet = 'resetBalanceCommittedToWallet',
  setLoginError = 'setLoginError',
  setLoginErrorMessage = 'setLoginErrorMessage',
  setTwoFactorError = 'setTwoFactorError',
  setCommitDepositError = 'setCommitDepositError',
  setNoteDepositError = 'setNoteDepositError',
  resetWalletError = 'resetWalletError',
  setNoteAcceptorEnabled = 'setNoteAcceptorEnabled',
  setDepositModalOpen = 'setDepositModalOpen',
  setNavigationItems = 'setNavigationItems',
  setModalDisplayed = 'setModalDisplayed',
  setSmoothAuthModalActive = 'setSmoothAuthModalActive',
  setContestEntryOfferedPayload = 'setContestEntryOfferedPayload',
  setContestEnteredPayload = 'setContestEnteredPayload',
  clearContestEntryOfferedPayload = 'clearContestEntryOfferedPayload',
  clearContestEnteredPayload = 'clearContestEnteredPayload',
  setContestOfferedBetContext = 'setContestOfferedBetContext',
  clearContestOfferedBetContext = 'clearContestOfferedBetContext',
  setContestSecondaryData = 'setContestSecondaryData',
  clearContestSecondaryData = 'clearContestSecondaryData'
}

/**
 * Marks a function as being able to handle unknown actions.
 * If a function directly used a union to add unknown actions to known actions, conditional logic based on known action type would give false failures on type safety checks.
 * If a function does not specify it handles unknown actions, callers (e.g. reducers) that handle other unrelated action types will fail type safety checks.
 * This is because in the version of TypeScript installed its not possible to exclude known enum/string union values from unknown.
 */
export function handlesUnknownActions<KnownAction extends { type: KnownActionType }, KnownActionType, Result>(
  callback: (action: KnownAction) => Result
): (action: KnownAction | { type: unknown }) => Result {
  return callback;
}
